import React, { useState, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Chart } from 'primereact/chart';

const PlotPage = () => {
    const { authState } = useOktaAuth();
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

        // Data for line chart
        const data = {
            labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'], // Months
            datasets: [
                {
                    label: 'SpinTest Failures (ver1)',
                    data: [10, 12, 8, 0, 5, 9, 6],
                    borderColor: 'rgba(75,192,192,1)',
                    backgroundColor: 'rgba(75,192,192,0.2)',
                    fill: false,
                    tension: 0.4,
                },
                {
                    label: 'SpinTest Failures (ver2)',
                    data: [5, 6, 0, 5, 6, 5, 4],
                    borderColor: 'rgba(255,99,132,1)',
                    backgroundColor: 'rgba(255,99,132,0.2)',
                    fill: false,
                    tension: 0.4,
                },
                {
                    label: 'EarlyAccessTargetCrmTest Failures (ver1)',
                    data: [0, 2, 0, 1, 0, 2, 1],
                    borderColor: 'rgba(153,102,255,1)',
                    backgroundColor: 'rgba(153,102,255,0.2)',
                    fill: false,
                    tension: 0.4,
                },
                {
                    label: 'EarlyAccessTargetCrmTest Failures (ver2)',
                    data: [2, 0, 1, 0, 0, 1, 1],
                    borderColor: 'rgba(255,206,86,1)',
                    backgroundColor: 'rgba(255,206,86,0.2)',
                    fill: false,
                    tension: 0.4,
                },
                {
                    label: 'LoginTest Failures (ver1)',
                    data: [3, 4, 2, 0, 3, 0, 2],
                    borderColor: 'rgba(54,162,235,1)',
                    backgroundColor: 'rgba(54,162,235,0.2)',
                    fill: false,
                    tension: 0.4,
                },
                {
                    label: 'LoginTest Failures (ver2)',
                    data: [1, 0, 1, 2, 0, 1, 1],
                    borderColor: 'rgba(255,159,64,1)',
                    backgroundColor: 'rgba(255,159,64,0.2)',
                    fill: false,
                    tension: 0.4,
                },
                {
                    label: 'PurchaseFlowTest Failures (ver1)',
                    data: [5, 0, 7, 3, 6, 2, 0],
                    borderColor: 'rgba(100,181,246,1)',
                    backgroundColor: 'rgba(100,181,246,0.2)',
                    fill: false,
                    tension: 0.4,
                },
                {
                    label: 'PurchaseFlowTest Failures (ver2)',
                    data: [0, 1, 0, 4, 3, 0, 1],
                    borderColor: 'rgba(255,87,34,1)',
                    backgroundColor: 'rgba(255,87,34,0.2)',
                    fill: false,
                    tension: 0.4,
                },
                {
                    label: 'NotificationTest Failures (ver1)',
                    data: [0, 1, 0, 0, 0, 1, 0],
                    borderColor: 'rgba(46,125,50,1)',
                    backgroundColor: 'rgba(46,125,50,0.2)',
                    fill: false,
                    tension: 0.4,
                },
                {
                    label: 'NotificationTest Failures (ver2)',
                    data: [1, 0, 2, 0, 0, 2, 0],
                    borderColor: 'rgba(69,90,100,1)',
                    backgroundColor: 'rgba(69,90,100,0.2)',
                    fill: false,
                    tension: 0.4,
                },
                {
                    label: 'Pass Percentage',
                    data: [80, 78, 65.5, 77, 88, 90, 89], // Sum of failures for version 1 and version 2
                    borderColor: 'rgba(255,255,255,0.8)',
                    backgroundColor: 'rgba(69,90,100,0.2)',
                    borderDash: [5, 5],
                    fill: false,
                    tension: 0.4,
                },
            ],
        };

        const options = {
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    labels: {
                        color: textColor,
                    },
                },
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                    },
                },
                y: {
                    ticks: {
                        color: textColorSecondary,
                    },
                    grid: {
                        color: surfaceBorder,
                    },
                },
            },
        };

        setChartData(data);
        setChartOptions(options);
    }, []);

    if (!authState || !authState.isAuthenticated) {
        return (
            <div style={{ marginTop: '20px', padding: '20px', zIndex: '1000' }}>
                Login into Okta before continuing!
            </div>
        );
    } else {
        return (
            <div style={{ marginTop: '10px', padding: '20px', zIndex: '1000' }}>
                <h1>Plot page</h1>
                <div
                    style={{
                        width: '90%',
                        height: '70vh',
                        margin: '0 auto',
                        position: 'relative', // Critical for canvas resizing
                    }}
                >
                    <Chart type="line" data={chartData} options={chartOptions} />
                </div>
            </div>
        );
    }
};

export default PlotPage;
